export enum PatientMessageCategory {
  GENERAL = "general",
  MEDICAL_RECORDS = "medical_records",
}
